import {useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {DrawerComponent} from '../../../assets/ts/components'
import {WithChildren} from '../../../helpers'

const Content = ({children}: WithChildren) => {
  const {config, classes} = useLayout()
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  // Dynamic container type based on route
  const getDynamicContainer = () => {
    // Use container-fluid for dashboard, container-xxl for everything else
    if (location.pathname === '/dashboard') {
      return 'fluid'
    }
    return 'fixed' // This will map to container-xxl
  }

  const appContentContainer = getDynamicContainer()

  return (
    <div
      id='kt_app_content'
      className={clsx('', classes.content.join(' '), config?.app?.content?.class)}
    >
      {appContentContainer ? (
      <div
        id='kt_app_content_container'
        className={clsx('app-container', classes.contentContainer.join(' '), {
        'container-xxl': appContentContainer === 'fixed',
        'container-fluid': appContentContainer === 'fluid',
        })}
        style={{minHeight: 'calc(100vh - 200px)'}}

      >
        {children}
      </div>
      ) : (
      <>{children}</>
      )}
    </div>
  )
}

export {Content}
